module.exports = __webpack_public_path__ + "static/media/label.065c6e36.png";